import "./index.css";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "nprogress/nprogress.css";
import "src/assets/css/prism.css";
import "src/assets/css/global.css";
import "src/mixins/chartjs";
import "src/mixins/prismjs";
import { enableES5 } from "immer";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { SettingsProvider } from "src/context/SettingsContext";
import { store } from "src/store";
import { restoreSettings } from "src/utils/settings";
import App from "src/App";
import { KeycloakInit } from "./auth";
enableES5();

const settings = restoreSettings();

// const app = () => {
ReactDOM.render(
  <Provider store={store}>
    <SettingsProvider settings={settings}>
      <App />
    </SettingsProvider>
  </Provider>,
  document.getElementById("root")
);
// };

// KeycloakInit(app);
